import React, { useEffect, useState } from 'react';
import {
    Users,
    Monitor,
    LogOut,
    LogIn,
    Search,
    RefreshCw,
} from 'lucide-react';
import axios from 'axios';
import { API_BASE_URL } from '../../../../api';
import './SessionManagement.css';

const SessionManagement = () => {
    const [sessionList, setSessionList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        fetchSessions();
    }, []);

    const fetchSessions = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_BASE_URL}/api/admin/config/sessions`, {
                headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` }
            });

            const data = response.data;
            if (data && Array.isArray(data)) {
                setSessionList(data);
            } else {
                console.warn("Sessions data is not an array:", data);
                setSessionList([]);
            }
        } catch (error) {
            console.error("Erreur sessions:", error);
            setSessionList([]);
        } finally {
            setLoading(false);
        }
    };

    const safeList = Array.isArray(sessionList) ? sessionList : [];
    const filteredSessions = safeList.filter(s => {
        if (!s || !s.user) return false;
        const name = `${s.user.firstName || ''} ${s.user.lastName || ''}`.toLowerCase();
        const email = (s.user.email || '').toLowerCase();
        const term = (searchTerm || '').toLowerCase();
        return name.includes(term) || email.includes(term);
    });

    return (
        <div className="session-mgmt-page">
            <div className="session-mgmt-header">
                <div>
                    <h1>Gestion des Sessions & Sécurité</h1>
                    <p>Surveillez les connexions actives et configurez les délais d'expiration</p>
                </div>

                <button className="session-mgmt-refresh-btn" onClick={fetchSessions} disabled={loading}>
                    <RefreshCw size={16} className={loading ? "session-mgmt-spin" : ""} />
                    {loading ? "Chargement..." : "Actualiser"}
                </button>
            </div>

            <div className="session-mgmt-toolbar">
                <div className="session-mgmt-search">
                    <Search size={18} />
                    <input
                        type="text"
                        placeholder="Rechercher un utilisateur..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div className="session-mgmt-count">
                    {filteredSessions.length} résultat{filteredSessions.length > 1 ? "s" : ""}
                </div>
            </div>

            <div className="session-mgmt-table-wrapper">
                <table className="session-mgmt-table">
                    <thead>
                    <tr>
                        <th>Utilisateur</th>
                        <th>Début de session</th>
                        <th>Fin de session</th>
                        <th>Durée</th>
                        <th>Appareil / IP</th>
                        <th>Statut</th>
                    </tr>
                    </thead>
                    <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={6} className="session-mgmt-empty">
                                <RefreshCw size={32} className="session-mgmt-spin" />
                                <div>Chargement des sessions...</div>
                            </td>
                        </tr>
                    ) : filteredSessions.length === 0 ? (
                        <tr>
                            <td colSpan={6} className="session-mgmt-empty">
                                <Users size={40} />
                                <div>Aucune session trouvée</div>
                            </td>
                        </tr>
                    ) : (
                        filteredSessions.map((s) => {
                            const duration = s.logoutAt ?
                                Math.round((new Date(s.logoutAt) - new Date(s.loginAt)) / 60000) :
                                null;

                            return (
                                <tr key={s.id}>
                                    <td>
                                        <div className="session-mgmt-user-cell">
                                            <div className="session-mgmt-avatar">
                                                {s.user?.firstName?.[0]}{s.user?.lastName?.[0]}
                                            </div>
                                            <div>
                                                <div className="session-mgmt-primary">{s.user?.firstName} {s.user?.lastName}</div>
                                                <div className="session-mgmt-sub">{s.user?.email}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="session-mgmt-datetime">
                                            <LogIn size={14} color="#10b981" />
                                            {new Date(s.loginAt).toLocaleString()}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="session-mgmt-datetime">
                                            <LogOut size={14} color={s.logoutAt ? "#ef4444" : "#94a3b8"} />
                                            {s.logoutAt ? new Date(s.logoutAt).toLocaleString() : 'Active'}
                                        </div>
                                    </td>
                                    <td>
                                        {duration !== null ? (
                                            <span className="session-mgmt-duration">{duration} min</span>
                                        ) : (
                                            <span className="session-mgmt-duration is-active">En cours</span>
                                        )}
                                    </td>
                                    <td className="session-mgmt-device">
                                        <div className="session-mgmt-device-row">
                                            <Monitor size={12} /> {s.ipAddress || '127.0.0.1'}
                                        </div>
                                        <div className="session-mgmt-device-sub">
                                            {s.userAgent || 'Navigateur standard'}
                                        </div>
                                    </td>
                                    <td>
                                        {!s.logoutAt ? (
                                            <span className="session-mgmt-status is-online">ACTIF</span>
                                        ) : (
                                            <span className="session-mgmt-status is-offline">TERMINÉ</span>
                                        )}
                                    </td>
                                </tr>
                            );
                        })
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SessionManagement;